import { ReactElement, useEffect, useRef } from "react";

interface IMobileSwipeProps {
  handlePrev: () => void;
  handleNext: () => void;
  children: ReactElement;
}

const MobileSwipe = ({
  handlePrev,
  handleNext,
  children,
}: IMobileSwipeProps) => {
  const swipeRef = useRef<HTMLDivElement>(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e: TouchEvent) => {
    if (e.touches.length > 1) {
      return;
    }
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX; // 初始化 touchEndX
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (e.touches.length > 1) {
      return;
    }
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: TouchEvent) => {
    if (e.touches.length > 1) {
      return;
    }
    const deltaX = touchStartX.current - touchEndX.current;
    if (Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // 处理左滑动事件
        handleNext();
      }else{
        // 处理右滑动事件
        handlePrev();
      }
    }
  };

  useEffect(() => {
    const element = swipeRef.current;
    if (!element) return;
    element.addEventListener("touchstart", handleTouchStart);
    element.addEventListener("touchmove", handleTouchMove);
    element.addEventListener("touchend", handleTouchEnd);

    return () => {
      element.removeEventListener("touchstart", handleTouchStart);
      element.removeEventListener("touchmove", handleTouchMove);
      element.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  return <div ref={swipeRef}>{children}</div>;
};

export default MobileSwipe;
